<template>
  <div class="create-page">
    <div class="header">
      <h1>{{ author.name }}</h1>
    </div>
    <div class="content">
      <ul class="bookDetailsList">
        <li
          v-for="publication in publications"
          :key="publication.guid"
          class="bookDetailsItem"
        >
          <publication-details :publication="publication"></publication-details>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import PublicationDetails from '../components/PublicationDetails';

export default {
  name: 'author',
  components: {
    'publication-details': PublicationDetails,
  },
  data() {
    return {
      publications: [],
      author: {},
    };
  },
  async mounted() {
    await this.getAuthor();
    this.getAuthorPublications();
  },
  methods: {
    async getAuthor() {
      return axios
        .get(`/author/${this.$route.params.guid}`)
        .then((response) => {
          this.author = response.data;
        });
    },
    async getAuthorPublications() {
      if (this.author) {
        axios
          .get(`/author/${this.author.guid}/publications`)
          .then((response) => {
            this.publications = response.data.data;
          });
      }
    },
  },
};
</script>
